export default "__VITE_ASSET__BPjP8Zv3__"